import Vue from "vue";
import Vuex from 'vuex';
import App from "./App.vue";
import router from "./router";
import { default as Adal } from 'vue-adal';
import store from './store/index';

//Venors
import "bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";


//Styles
import "./styles/main.scss";

Vue.config.productionTip = false;
Vue.use(Vuex);

window.store = store

Vue.use(Adal, {
  config: {
    tenant: process.env.VUE_APP_TENANTID,
    clientId: process.env.VUE_APP_CLIENTID,
    redirectUri: process.env.VUE_APP_REDIRECT_URL,
    cacheLocation: 'localStorage'
  },
  requireAuthOnInitialize: true,
  router: router
})

new Vue({
  router,
  store: window.store,
  render: (h) => h(App),
}).$mount("#app");
